import NoticeToUsers from './NoticeToUsers';

export default NoticeToUsers;
